import type { Adventure } from '../../types'

// More or Less Adventure - Age 3-4 - Comparing quantities
export const tillyCompareCorrect = [
  "Perfect! You can spot more and less!",
  "That's right! Great comparing!",
  "Excellent eye! You know your amounts!",
  "Wonderful! You're a comparison expert!",
  "Yes! You counted them up!",
  "Super job! More and less mastered!",
  "Brilliant comparison skills!",
  "You got it! That's the answer!",
  "Perfect counting and comparing!",
  "You're so good at this!"
]

export const tillyCompareWrong = [
  "Let's count together! Which group has more?",
  "Try counting each group carefully!",
  "Almost! Count them one by one!",
  "So close! Look at both groups again!",
  "Good try! Let's compare: more or less?",
  "Count with me: 1, 2, 3... which is more?",
  "Try again! Look at the pictures!",
  "You're learning! Count both groups!",
  "Think about it - which pile is bigger?",
  "Let's compare again!"
]

export const moreOrLessAdventure: Adventure = {
  id: 'more-or-less',
  title: 'More or Less',
  theme: 'counting',
  targetAge: '3',
  difficulty: 'easy',
  estimatedDuration: 8,
  segments: {
    intro: {
      id: 'intro',
      tillyLine: "Hello friend! I'm Tilly! Today we are going to play 'More or Less' - comparing groups to see which has more!",
      duration: 4
    },
    story1: {
      id: 'story-1',
      tillyLine: "Look! I have 3 cookies and you have 2 cookies. I have MORE cookies! Can you spot which group has more?",
      duration: 5
    },
    choice1: [
      {
        id: 'compare',
        label: 'Compare groups!',
        tillyLine: "Let's see which group is bigger!",
        nextState: 'quiz-1'
      },
      {
        id: 'count',
        label: 'Count things!',
        tillyLine: "Counting helps us compare!",
        nextState: 'story-2'
      }
    ],
    quiz1: {
      id: 'quiz-1',
      type: 'count-and-tap',
      question: 'Which plate has MORE cookies?',
      tillyPrompt: 'Count the cookies! 4 or 2?',
      options: [
        { id: 'four', label: '🍪🍪🍪🍪 4', isCorrect: true },
        { id: 'two', label: '🍪🍪 2', isCorrect: false }
      ],
      targetNumber: 4,
      objectEmoji: '🍪'
    } as any,
    story2: {
      id: 'story-2',
      tillyLine: "Great comparing! Now let's try with apples! Sometimes we also need to find which group has LESS. That means fewer!",
      duration: 4
    },
    choice2: [
      {
        id: 'less',
        label: 'Find LESS apples!',
        tillyLine: "LESS means the smaller group!",
        nextState: 'quiz-2'
      },
      {
        id: 'more',
        label: 'Find MORE apples!',
        tillyLine: "MORE means the bigger group!",
        nextState: 'quiz-2'
      }
    ],
    quiz2: {
      id: 'quiz-2',
      type: 'count-and-tap',
      question: 'Which basket has LESS apples?',
      tillyPrompt: 'Find the smaller number! 5 or 3?',
      options: [
        { id: 'five', label: '🍎🍎🍎🍎🍎 5', isCorrect: false },
        { id: 'three', label: '🍎🍎🍎 3', isCorrect: true }
      ],
      targetNumber: 3,
      objectEmoji: '🍎'
    } as any,
    challenge: {
      intro: {
        id: 'challenge-intro',
        tillyLine: "You're a comparison master! Challenge Round: Spot more or less!",
        duration: 4
      },
      quizzes: [
        {
          id: 'challenge-1',
          type: 'count-and-tap',
          question: 'Which jar has MORE marbles?',
          tillyPrompt: '6 or 4? Pick the bigger number!',
          options: [
            { id: 'six', label: '🔵🔵🔵🔵🔵🔵 6', isCorrect: true },
            { id: 'four', label: '🔵🔵🔵🔵 4', isCorrect: false }
          ],
          targetNumber: 6,
          objectEmoji: '🔵'
        } as any,
        {
          id: 'challenge-2',
          type: 'count-and-tap',
          question: 'Which tree has LESS birds?',
          tillyPrompt: '2 or 5? Pick the smaller number!',
          options: [
            { id: 'two', label: '🐦🐦 2', isCorrect: true },
            { id: 'five', label: '🐦🐦🐦🐦🐦 5', isCorrect: false }
          ],
          targetNumber: 2,
          objectEmoji: '🐦'
        } as any,
        {
          id: 'challenge-3',
          type: 'count-and-tap',
          question: 'Are these groups EQUAL?',
          tillyPrompt: 'Both have 4 stars!',
          options: [
            { id: 'equal', label: 'Yes! Equal! ⭐⭐⭐⭐', isCorrect: true },
            { id: 'notequal', label: 'No, different!', isCorrect: false }
          ],
          targetNumber: 4,
          objectEmoji: '⭐'
        } as any
      ]
    },
    reward: {
      tillyLine: "Fantastic! You mastered more, less, and equal! You're a Comparison Champion!",
      badgeName: 'Comparison Pro',
      badgeIcon: '⚖️',
      nextPreview: 'Next time, we will learn subtraction with pirates!'
    }
  }
}
